import { render, staticRenderFns } from "./JoinedTable.vue?vue&type=template&id=61a89dda&scoped=true"
import script from "./JoinedTable.vue?vue&type=script&lang=js"
export * from "./JoinedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a89dda",
  null
  
)

export default component.exports